import React from "react";

import { Header as PrimaryHeader } from "components";
import { IAuthState } from "models/auth.model";

type Props = {
    auth: IAuthState;
};

export default function Header({ auth }: Props) {
    return (
        <>
            <PrimaryHeader auth={auth} />
        </>
    );
}
